import { CustomCartAlert } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CartAlerts/components/CustomCartAlert';
import { Text } from '@/components/shared/components/Text';

export const IncompleteAlert = () => {
  return (
    <CustomCartAlert>
      <Text tId={'CART_ALERT_ARTICLE_INCOMPLETE'}></Text>
    </CustomCartAlert>
  );
};
